import { Component, inject, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { FinancingCalculatorFormComponent } from './financing-calculator-form/financing-calculator-form.component';
import { IconBoxComponent } from '@atoms/icon-box/icon-box.component';
import { ImageComponent } from '@atoms/image/image.component';
import { TitleComponent } from '@atoms/title/title.component';
import { CarItem } from '@models/car.model';
import { FinancingCalculator } from '@models/financing-calculator.model';
import { PartnersService } from '@services/partners.service';

@Component({
  selector: 'app-financing-calculator',
  imports: [TranslateModule, FinancingCalculatorFormComponent, ImageComponent, TitleComponent, IconBoxComponent],
  templateUrl: './financing-calculator.component.html',
  styleUrl: './financing-calculator.component.scss',
})
export class FinancingCalculatorComponent {
  @Input() car: CarItem = {} as CarItem;
  public financingCalculator: FinancingCalculator = { advance: 0, loanType: '1', months: 24 };
  public partnersService = inject(PartnersService)

  setFinancingCalculator(data: FinancingCalculator): void {
    this.financingCalculator = data;
  }
}
